import type { Condition } from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import type { Step } from '@/components/wizard/Step';

import { RansomwareConditionEditor } from './ransomwareConditionEditor';

export interface RansomwareByConditionState {
  editMode: boolean;
  condition?: Condition;
  resourcesScopeType: ResourcesScopeType;
  include: string[];
  exclude: string[];
}

export const RansomwareByConditionFlow: Step<RansomwareByConditionState> = {
  id: 'condition',
  Component: RansomwareConditionEditor,
};
